// extracted by mini-css-extract-plugin
export default {"container":"Sn-z","bubbleNav":"Tn-z","graphic":"Un-z","contact":"Vn-z"};